import { createCaller, createCallerContext } from '@sunfish/api';
import type { Route } from './+types/NotFound';
import { NotFoundContent } from '~components/not-found-content';

export async function loader({ request }: Route.LoaderArgs) {
	const url = new URL(request.url);
	const pathParts = url.pathname.split('/').filter(Boolean);

	// Try to extract tenantSlug and landingSlug from the URL path
	// Expected format: /{tenantSlug}/{landingSlug}/...
	const tenantSlug = pathParts[0];
	const landingSlug = pathParts[1];

	if (!tenantSlug || !landingSlug) {
		return { logoUrl: null, backLink: 'https://sunfishevents.com', backLinkText: 'Sunfish Events' };
	}

	try {
		const caller = createCaller(await createCallerContext(request));
		const landingPageData = await caller.landingPages.getLandingPageBySlug({
			slug: landingSlug
		});

		if (landingPageData) {
			const logoUrl = landingPageData.signedLogoUrl || null;
			const landingPagePath = `/${tenantSlug}/${landingSlug}`;
			const registerPath = `/${tenantSlug}/${landingSlug}/register`;

			// Use landing page as back link if published, otherwise registration
			const backLink = landingPageData.publishedAt ? landingPagePath : registerPath;
			const backLinkText = landingPageData.publishedAt ? 'Back to Event' : 'Back to Registration';

			return { logoUrl, backLink, backLinkText };
		}
	} catch {
		// If we can't fetch landing page data, fall back to defaults
	}

	return { logoUrl: null, backLink: 'https://sunfishevents.com', backLinkText: 'Sunfish Events' };
}

export default function NotFound({ loaderData }: Route.ComponentProps) {
	const { logoUrl, backLink, backLinkText } = loaderData;
	return <NotFoundContent logoUrl={logoUrl} backLink={backLink} backLinkText={backLinkText} />;
}
